import { SpecialCardSection } from "../../components/SpecialCard";
import { cardData } from "../../data/services";

export default function Section2() {
  return (
    <SpecialCardSection
      id="servicesMain"
      items={cardData}
      variant="service"
      eyebrow="Our Capabilities"
      heading="Overview of Medical Billing Services in the USA"
      description="Medical billing services streamline healthcare billing by converting clinical data into accurate insurance claims through electronic processing and structured workflows. They ensure correct capture of diagnoses, procedures, and charges for timely submission to payers.
Beyond claim submission, medical billing includes accounts management, claim tracking, denial resolution, outstanding balance follow-ups, and financial reporting to support effective revenue cycle management (RCM) and planning.
"
    />
  );
}
